import styled from 'styled-components/native'
import { SecondaryButton } from 'APP/Components/Buttons'
import Typography from 'APP/Converse/Typography'

export const UploadButton = styled(SecondaryButton)`
  margin-bottom: ${({ theme }) => theme.insets.bottom}px;
`

export const LayoutWrapper = styled.View<{ $isWeb?: boolean }>`
  flex: 1;
  width: 100%;
  min-height: 0;
  justify-content: flex-start;
  flex-direction: column;
  ${({ $isWeb }) => ($isWeb ? '' : 'position: relative;')}
  ${({ $isWeb, theme }) => ($isWeb ? `gap: ${theme.metrics.baseMargin * 1.5}px;` : '')}
`

export const UploadScrollView = styled.ScrollView`
  flex: 1;
  width: 100%;
  min-height: 0;
`

export const OldContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  text-align: right;
  padding-top: 2rem;
  display: flex;
  flex-grow: 1;
`

export const Container = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  text-align: right;
  padding-top: 2rem;
  display: flex;
  width: 100%;
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export const FileInputContainer = styled.View`
  width: 100%;
  flex-shrink: 1;
`

export const FilePreviewWrapper = styled.View<{ isDimmed: boolean }>`
  opacity: ${({ isDimmed }) => (isDimmed ? 0.35 : 1)};
  transition: opacity 150ms ease-in-out;
`

export const ButtonContainer = styled.View`
  display: flex;
  flex-direction: row-reverse;
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 4}px;
  align-items: flex-end;
`

export const ButtonWrapper = styled.View`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-bottom: ${({ theme }) => theme.insets.bottom}px;
  background-color: ${({ theme }) => theme.colors.background};
  z-index: 2;
`

export const WebButtonWrapper = styled.View`
  position: sticky;
  bottom: 0;
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.background};
`

export const InlineError = styled(Typography)`
  color: ${({ theme }) => theme.colors.error};
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
`

export const UploadingPill = styled.View<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  background-color: ${({ theme }) => theme.colors.buttonPrimary};
  height: ${({ theme }) => theme.metrics.button.height}px;
  padding-vertical: 0px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.large}px;
  width: ${({ fullWidth, theme }) => (fullWidth ? '100%' : `${theme.metrics.button.width}px`)};
  ${({ fullWidth }) => (fullWidth ? 'align-self: stretch;' : '')}
  justify-content: center;
`

export const RootView = styled.View`
  flex: 1;
  align-self: stretch;
`

export const WebRootView = styled.View`
  flex: 1;
  width: 100%;
`
